import styled from 'styled-components'

const positionTemplate = {
  position: String,
}

const stylePosition = (position) => {
  switch (position) {
    case 'center':
      return `
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999;
      `;
    default:
      return `
        
      `;
  }
}

export const StyledSpinner = styled('div', positionTemplate)`
  ${({ pt }) => pt && `padding-top: ${pt}px`};
  ${({ pb }) => pb && `padding-bottom: ${pb}px`};
  ${({position}) => stylePosition(position)}
`;

export const StyledFragmentSpinner = styled('div', positionTemplate)`
  ${({position}) => stylePosition(position)};
`;

export const StyledLoadingWrapper = styled.div`
  width: 100%;
  height: 150px;
  background: ${({theme}) => theme.surface.spinnerOverlay};
  background: ${({theme}) => theme.surface.spinnerGradient};
  transition: all .3s ease;
  position: absolute;
  bottom: 0;
`;

export const StyledSuspenseWrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;